<div class="row justify-content-center g-0">
    <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
        
        <div class="d-flex justify-content-between mx-2 my-2">
            <h2>
                <app-superelf-icon [icon]=facTrophy></app-superelf-icon>
                <span class="ms-1">prijzenkasten</span>
            </h2>
            <div class="form-check form-switch pointer">
                <input type="checkbox" class="form-check-input pointer" id="goat-switch" [checked]="goatToggle" (change)="toggleGoat()">
                <label class="form-check-label pointer" for="goat-switch"><img height="40rem" src="assets/images/goat-small.png" /></label>
            </div>
            <!-- <div class="form-check form-switch">
                <input class="form-check-input pointer" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                <label class="form-check-label pointer" for="flexSwitchCheckDefault">details</label>
            </div> -->            
        </div>        

        @if(!processing()){
            @if(pool){
                <div>
                    <table class="table">
                        <thead>                  
                            <tr>
                                <th>
                                </th>
                                @if(goatToggle){
                                    <th class="text-end">
                                        <img height="25rem" src="assets/images/goat-small.png" />
                                    </th>
                                }
                                
                                <th class="text-end">
                                    <div><app-superelf-trophy-icon size="2x" [leagueName]="Competition"></app-superelf-trophy-icon></div>
                                    @if(goatToggle){
                                        <div>{{goatPoints.competitionTrophy}}p</div>
                                    } @else {
                                        <div class="fw-lighter">comp.</div>
                                    }
                                </th>
                                <th class="text-end">
                                    <div><app-superelf-trophy-icon size="2x" [leagueName]="Cup"></app-superelf-trophy-icon></div>
                                    @if(goatToggle){
                                        <div>{{goatPoints.cupTrophy}}p</div>
                                    } @else {
                                        <div class="fw-lighter">beker.</div>
                                    }
                                </th>
                                <th class="text-end">
                                    <div><app-superelf-trophy-icon size="2x" [leagueName]="SuperCup"></app-superelf-trophy-icon></div>
                                    @if(goatToggle){
                                        <div>{{goatPoints.supercupTrophy}}p</div>
                                    } @else {
                                        <div class="fw-lighter">s. cup</div>
                                    }                                    
                                </th>
                                <th class="text-end">
                                    <div><app-superelf-badge-icon></app-superelf-badge-icon></div>
                                    @if(goatToggle){
                                        <div>{{goatPoints.badge}}p</div>
                                    } @else {
                                        <div class="fw-lighter">badge</div>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(achievementListItem of achievementListItems; track achievementListItem) {
                            <tr>
                                <td>                                    
                                    {{achievementListItem.name}} 
                                    @if(achievementListItem.isGoat){
                                        <img height="20rem" src="assets/images/goat-small.png" />
                                    }
                                </td>
                                @if(goatToggle){
                                    <td class="text-nowrap text-end">
                                        <span>{{achievementListItem.goatTotalPoints}}</span>
                                    </td>
                                    <td class="text-nowrap text-end">
                                        @if(achievementListItem.leagueTrophies.get(Competition)?.length){
                                            <span>{{achievementListItem.leagueTrophies.get(Competition)?.length}}x</span>
                                        }
                                    </td>
                                    <td class="text-nowrap text-end">
                                        @if(achievementListItem.leagueTrophies.get(Cup)?.length){
                                        <span>{{achievementListItem.leagueTrophies.get(Cup)?.length}}x</span>
                                        }
                                    </td>
                                    <td class="text-nowrap text-end">
                                        @if(achievementListItem.leagueTrophies.get(SuperCup)?.length){
                                        <span>{{achievementListItem.leagueTrophies.get(SuperCup)?.length}}x</span>
                                        }
                                    </td>
                                } @else {
                                    <td class="text-end">
                                        @for(trophy of achievementListItem.leagueTrophies.get(Competition); track trophy) {
                                        <div class="badge bg-secondary mb-1 ms-1 px-1 pointer" (click)="openLinkNewTab(pool, trophy, Competition)">
                                            {{trophy.seasonShortName}}</div>
                                        }
                                    </td>
                                    <td class="text-end">
                                        @for(trophy of achievementListItem.leagueTrophies.get(Cup); track trophy) {
                                        <div class="badge bg-secondary mb-1 ms-1 px-1 pointer" (click)="openLinkNewTab(pool, trophy, Cup)">
                                            {{trophy.seasonShortName}}</div>
                                        }
                                    </td>
                                    <td class="text-end">
                                        @for(trophy of achievementListItem.leagueTrophies.get(SuperCup); track trophy) {
                                        <div class="badge bg-secondary mb-1 ms-1 px-1 pointer" (click)="openLinkNewTab(pool, trophy, SuperCup)">
                                            {{trophy.seasonShortName}}</div>
                                        }
                                    </td>
                                }

                                <td class="text-end">
                                    @if(goatToggle && achievementListItem.badges.length){
                                        <div>{{achievementListItem.badges.length}}x</div>
                                    }
                                    @if(!goatToggle){                                        
                                        <button type="button" class="btn btn-sm btn-secondary"
                                            (click)="openUserBadgesInfoModal(achievementListItem)">{{achievementListItem.badges.length}}x
                                        </button>                        
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>                
                    </table>
                </div>
            }
        } @else {
            <h2 class="text-center">
                <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
            </h2>
        }     
    </div>
</div>

@if(!processing() && pool){    
    <app-pool-navbar [current]="Achievements" [pool]="pool" [poolUser]="poolUserFromSession">
    </app-pool-navbar>    
}

<!-- <ng-template #contentMessageTitle let-message="message" let-end="end">
    <div class="d-flex mx-1" [ngClass]="{'flex-row-reverse': end}">
        <fa-icon [icon]=faUserCircle></fa-icon>

        <span class="ms-1">{{message.getUser().getName()}}</span>

        <span class="mx-3">{{getMessageDate(message.getDate())}}</span>
    </div>
</ng-template> -->